export { default } from './info-alert';
